import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function Footer() {
  const { t } = useTranslation()
  const year = new Date().getFullYear()

  return (
    <footer className="border-t mt-12">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <Link to="/" className="text-sm font-bold text-foreground hover:opacity-80 transition-opacity">
              RatyGo
            </Link>
            <p className="text-xs text-muted-foreground mt-1 max-w-md">
              {t('footer.disclaimer')}
            </p>
          </div>
          <nav className="flex items-center gap-4">
            <Link to="/" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.calculator')}
            </Link>
            <Link to="/blog" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.blog')}
            </Link>
            <Link to="/o-kalkulatorze" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('nav.about')}
            </Link>
            <a href="mailto:ratygoinfo@gmail.com" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.contact')}
            </a>
          </nav>
        </div>
        <div className="mt-4 pt-4 border-t border-border/50">
          <p className="text-[11px] text-muted-foreground/60 text-center">
            &copy; {year} RatyGo. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  )
}
